export const NavDataConfig = [
    {
        to: 'home',
        label: 'Home',
    },
    {
        to: 'about',
        label: 'About',
    },
    
    {
        to: 'services',
        label: 'Services',
    },
    {
        to: 'whyChooseUs',
        label: 'WhyChooseUs',
    },
    {
        to: 'clients',
        label: 'Clients',
    },
    {
        to: 'contact',
        label: 'Contact',
    },
]